module.exports = __webpack_public_path__ + "static/media/guk_logo.af623006.png";